import { useLocation, useNavigate, useRouter } from "@tanstack/react-router";
import type { ValidRoutes } from "routes";

type SearchParams = {
	sub_sk?: string;
	sub_cid?: string;
	redirect_uri?: string;
};

export default function useNav() {
	const location = useLocation();
	const navigate = useNavigate();
	const router = useRouter();
	const search = location.search as SearchParams;

	const ssk = search.sub_sk;
	const cid = search.sub_cid;

	return {
		location,
		search,
		keys: { ssk, cid },
		go: navigate,
		replace: (to: ValidRoutes) => navigate({ to, replace: true }),
		back: () => router.history.back(),
		tab: (to: string) => window.open(to, "_blank"),
		open: (to: string) => window.location.href = to,
		preserve: (to: ValidRoutes) => navigate({ to, search: location.search })
	};
};